import { digestMessage } from "./hashUtils.es.js";
import { formSchema } from "../../../server/validation/defaultSchema.es.js";
import { logger } from "../../../utils/logger.es.js";
import "../../../_commonjsHelpers-7a77ea84.js";
import "../../constants/analytics.es.js";
const stateList = {
  alabama: "al",
  alaska: "ak",
  "american samoa": "as",
  arizona: "az",
  arkansas: "ar",
  california: "ca",
  colorado: "co",
  connecticut: "ct",
  delaware: "de",
  "district of columbia": "dc",
  "federated states of micronesia": "fm",
  florida: "fl",
  georgia: "ga",
  guam: "gu",
  hawaii: "hi",
  idaho: "id",
  illinois: "il",
  indiana: "in",
  iowa: "ia",
  kansas: "ks",
  kentucky: "ky",
  louisiana: "la",
  maine: "me",
  "marshall islands": "mh",
  maryland: "md",
  massachusetts: "ma",
  michigan: "mi",
  minnesota: "mn",
  mississippi: "ms",
  missouri: "mo",
  montana: "mt",
  nebraska: "ne",
  nevada: "nv",
  "new hampshire": "nh",
  "new jersey": "nj",
  "new mexico": "nm",
  "new york": "ny",
  "north carolina": "nc",
  "north dakota": "nd",
  "northern mariana islands": "mp",
  ohio: "oh",
  oklahoma: "ok",
  oregon: "or",
  palau: "pw",
  pennsylvania: "pa",
  "puerto rico": "pr",
  "rhode island": "ri",
  "south carolina": "sc",
  "south dakota": "sd",
  tennessee: "tn",
  texas: "tx",
  utah: "ut",
  vermont: "vt",
  "virgin islands": "vi",
  virginia: "va",
  washington: "wa",
  "west virginia": "wv",
  wisconsin: "wi",
  wyoming: "wy"
};
const getState = (state) => {
  const abbreviation = state.length === 2 && Object.values(stateList).includes(state.toLowerCase());
  if (abbreviation) {
    return state.toLowerCase();
  }
  const stateName = stateList[state.toLowerCase()];
  if (stateName) {
    return stateName;
  }
  return void 0;
};
const lowerCased = (value) => value.trim().toLowerCase();
const US_COUNTRY_CODE = 1;
const transformCity = (cityValue) => lowerCased(cityValue).replace(/[^a-zA-Z]/g, "");
const transformDate = (dateValue) => [
  dateValue.getUTCFullYear().toString().padStart(4, "0"),
  (dateValue.getUTCMonth() + 1).toString().padStart(2, "0"),
  dateValue.getUTCDate().toString().padStart(2, "0")
].join("");
const validateYesNo = (value, propName) => {
  const lower = lowerCased(value);
  if (lower !== "yes" && lower !== "no") {
    logger.error(`${propName} value should be "yes" or "no"`);
  }
  return lower;
};
const getFormData = async (formFields) => {
  const freedomPayload = {};
  const tealiumPayload = {};
  const processFields = {
    address: async (formFields2) => {
      freedomPayload.address = formFields2.address;
    },
    city: async (formFields2) => {
      const formatted = transformCity(formFields2.city);
      const digested = await digestMessage(formatted);
      if (formatted) {
        freedomPayload.city = formatted;
        freedomPayload.hash_city = digested;
        tealiumPayload.form_hash_city = digested;
      }
    },
    country: async (formFields2) => {
      const formatted = "us";
      const digested = await digestMessage(formatted);
      if (formFields2.address || formFields2.state || formFields2.zipcode) {
        freedomPayload.country = formatted;
        freedomPayload.hash_country = digested;
        tealiumPayload.form_hash_country = digested;
      }
    },
    date_of_birth: async (formFields2) => {
      if (!(formFields2.date_of_birth instanceof Date)) {
        freedomPayload.date_of_birth = formFields2.date_of_birth;
        return;
      }
      const formatted = transformDate(formFields2.date_of_birth);
      if (formatted) {
        const digested = await digestMessage(formatted);
        freedomPayload.date_of_birth = formatted;
        freedomPayload.hash_date_of_birth = digested;
        tealiumPayload.form_hash_date_of_birth = digested;
      }
    },
    email: async (formFields2) => {
      const formatted = lowerCased(formFields2.email);
      const digested = await digestMessage(formatted);
      freedomPayload.email = formatted;
      freedomPayload.hash_email = digested;
      tealiumPayload.form_hash_email = digested;
    },
    first_name: async (formFields2) => {
      const formatted = lowerCased(formFields2.first_name);
      const digested = await digestMessage(formatted);
      freedomPayload.first_name = formatted;
      freedomPayload.hash_first_name = digested;
      tealiumPayload.form_hash_first_name = digested;
    },
    last_name: async (formFields2) => {
      const formatted = lowerCased(formFields2.last_name);
      const digested = await digestMessage(formatted);
      freedomPayload.last_name = formatted;
      freedomPayload.hash_last_name = digested;
      tealiumPayload.form_hash_last_name = digested;
    },
    phone: async (formFields2) => {
      const formatted = `${US_COUNTRY_CODE}${formFields2.phone.replace(
        /[^.0-9]/g,
        ""
      )}`;
      const digested = await digestMessage(formatted);
      freedomPayload.phone = formatted;
      freedomPayload.hash_phone = digested;
      tealiumPayload.form_hash_phone = digested;
      const formattedPlus = `+${formatted}`;
      const digestedPlus = await digestMessage(formattedPlus);
      freedomPayload.hash_phone_plus = digestedPlus;
      tealiumPayload.form_hash_phone_plus = digestedPlus;
    },
    social_security: async (formFields2) => {
      freedomPayload.social_security = formFields2.social_security;
    },
    ss_amount: async (formFields2) => {
      freedomPayload.ss_amount = formFields2.ss_amount;
      tealiumPayload.form_ss_amount = formFields2.ss_amount;
    },
    ss_annual_income: async (formFields2) => {
      freedomPayload.ss_annual_income = formFields2.ss_annual_income;
      tealiumPayload.form_ss_annual_income = formFields2.ss_annual_income;
    },
    ss_co_applicant_income: async (formFields2) => {
      freedomPayload.ss_co_applicant_income = formFields2.ss_co_applicant_income;
      tealiumPayload.form_ss_co_applicant_income = formFields2.ss_co_applicant_income;
    },
    ss_purpose: async (formFields2) => {
      freedomPayload.ss_purpose = formFields2.ss_purpose;
      tealiumPayload.form_ss_purpose = formFields2.ss_purpose;
    },
    state: async (formFields2) => {
      const formatted = getState(lowerCased(formFields2.state));
      const digested = await digestMessage(formatted);
      if (formatted) {
        freedomPayload.state = formatted;
        freedomPayload.hash_state = digested;
        tealiumPayload.form_hash_state = digested;
        tealiumPayload.form_state = formatted;
      }
    },
    zipcode: async (formFields2) => {
      const formatted = formFields2.zipcode.substring(0, 5);
      const digested = await digestMessage(formatted);
      freedomPayload.zipcode = formatted;
      freedomPayload.hash_zipcode = digested;
      tealiumPayload.form_hash_zipcode = digested;
    },
    actual_debt: async (formFields2) => {
      freedomPayload.actual_debt = formFields2.actual_debt;
      tealiumPayload.form_actual_debt = formFields2.actual_debt;
    },
    actual_loan_amount: async (formFields2) => {
      freedomPayload.actual_loan_amount = formFields2.actual_loan_amount;
      tealiumPayload.form_actual_loan_amount = formFields2.actual_loan_amount;
    },
    actual_homeowner: async (formFields2) => {
      const value = validateYesNo(
        formFields2.actual_homeowner,
        "actual_homeowner"
      );
      freedomPayload.actual_homeowner = value;
      tealiumPayload.form_actual_homeowner = value;
    },
    ss_dti: async (formFields2) => {
      freedomPayload.ss_dti = formFields2.ss_dti;
      tealiumPayload.form_ss_dti = formFields2.ss_dti;
    },
    eh_cus_value_one: async (formFields2) => {
      freedomPayload.eh_cus_value_one = formFields2.eh_cus_value_one;
      tealiumPayload.form_eh_cus_value_one = formFields2.eh_cus_value_one;
    },
    ar_offer: async (formFields2) => {
      const value = validateYesNo(formFields2.ar_offer, "ar_offer");
      freedomPayload.ar_offer = value;
      tealiumPayload.form_ar_offer = value;
    },
    apl_offer: async (formFields2) => {
      const value = validateYesNo(formFields2.apl_offer, "apl_offer");
      freedomPayload.apl_offer = value;
      tealiumPayload.form_apl_offer = value;
    },
    ahl_offer: async (formFields2) => {
      const value = validateYesNo(formFields2.ahl_offer, "ahl_offer");
      freedomPayload.ahl_offer = value;
      tealiumPayload.form_ahl_offer = value;
    },
    indicative_state: async (formFields2) => {
      const value = lowerCased(formFields2.indicative_state);
      if (value === "az" || value === "ca") {
        freedomPayload.indicative_state = value;
        tealiumPayload.form_indicative_state = value;
      } else {
        logger.warn('indicative_state value should be "az" or "ca".');
      }
    }
  };
  try {
    await formSchema.validate(formFields, { abortEarly: false, strict: true });
  } catch (error) {
    logger.error("Validation failed:", error.errors);
  }
  for (const key of Object.keys(formFields)) {
    if (processFields[key]) {
      await processFields[key](formFields);
    }
  }
  return { freedomFormData: freedomPayload, tealiumFormData: tealiumPayload };
};
export {
  getFormData
};
